import clsx from "clsx";
import { ThumbsDownIcon, ThumbsUpIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useRefetchCandidacyInterests } from "@/hooks/refetches";
import { useCreateCandidacyInterest } from "@/hooks/mutations";
import { useSetCandidacyInCandidacies } from "@/hooks/sets";
import { Candidacy } from "@/types";

export const JobPipelineCandidateSheetCandidacyInterestButtons = ({
  candidacy,
  isInterested,
}: {
  candidacy: Candidacy;
  isInterested: boolean | null;
}) => {
  const { mutate: createCandidacyInterest, status } =
    useCreateCandidacyInterest();
  const refetchCandidacyInterests = useRefetchCandidacyInterests();
  const setCandidacyInCandidacies = useSetCandidacyInCandidacies();

  const handleClick = ({ isInterested }: { isInterested: boolean }) => {
    createCandidacyInterest(
      {
        candidacyId: candidacy.id,
        createCandidacyInterestRequest: {
          // TODO: Replace with actual note when we have a suitable UX.
          note: "placeholder",
          isInterested,
        },
      },
      {
        onSuccess: () => {
          refetchCandidacyInterests({ candidacyId: candidacy.id });
          setCandidacyInCandidacies({
            candidacy,
            isInterested,
          });
        },
      },
    );
  };

  return (
    <>
      <Button
        className={clsx(
          "rounded-full",
          // TODO: Somehow keep `bg-red-50` consistent with variant.
          isInterested === false && "pointer-events-none bg-red-50",
        )}
        disabled={status === "pending"}
        onClick={() => {
          handleClick({ isInterested: false });
        }}
        variant="outlineDestructive"
      >
        <ThumbsDownIcon className="h-4 w-4" />
        Not Interested
      </Button>
      <Button
        className={clsx(
          "rounded-full",
          // TODO: Somehow keep `bg-green-50` consistent with variant.
          isInterested === true && "pointer-events-none bg-green-50",
        )}
        disabled={status === "pending"}
        onClick={() => {
          handleClick({ isInterested: true });
        }}
        variant="outlineGreen"
      >
        <ThumbsUpIcon className="h-4 w-4" />
        Interested
      </Button>
    </>
  );
};
